export type RssItem = {
  xmltitle: string;
  xmldescription: string;
  xmlpubdate: string;
  xmllink: string;
  xmlimage: string;
};

const parseDate = (value: string) => {
  const date = new Date(value);
  const month = `0${date.getMonth() + 1}`.slice(-2);
  const day = `0${date.getDate()}`.slice(-2);
  return `${date.getFullYear()}.${month}.${day}`;
};

// note.com の RSS description は HTML を含むので、テキストだけ抽出して XSS 経路を絶つ
const stripHtml = (html: string): string => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  return (doc.body.textContent || "").replace(/\s+/g, " ").trim();
};

export const fetchRss = async (
  rssUrl: string,
  limit = 20,
): Promise<RssItem[]> => {
  const endpoint = `/road_note?url=${encodeURIComponent(rssUrl)}`;
  const response = await fetch(endpoint);
  if (!response.ok) {
    throw new Error(`failed to fetch rss: ${response.status}`);
  }
  const raw = await response.text();
  const xml = raw.replace(/&(?=[a-z_0-9]+=)/gi, "&amp;");
  const parser = new DOMParser();
  const xmlData = parser.parseFromString(xml, "text/xml");
  const articles = Array.from(
    xmlData.documentElement.getElementsByTagName("item"),
  ).slice(0, limit);

  return articles.map((article) => {
    const thumb = article.getElementsByTagName("media:thumbnail").length
      ? article.getElementsByTagName("media:thumbnail")[0].textContent ||
        "/assets/common/img/thumb_logo.jpg"
      : "/assets/common/img/thumb_logo.jpg";

    return {
      xmltitle: article.getElementsByTagName("title")[0]?.textContent || "",
      xmldescription: stripHtml(
        article.getElementsByTagName("description")[0]?.textContent || "",
      ),
      xmlpubdate: parseDate(
        article.getElementsByTagName("pubDate")[0]?.textContent || "",
      ),
      xmllink: article.getElementsByTagName("link")[0]?.textContent || "",
      xmlimage: thumb,
    };
  });
};
